<template>
  <ol class="base-list">
    <template v-for="(item, index) in items">
      <BaseListItem :item="item" :uppercase="uppercase" :key="'baseListItem_' + index"/>
    </template>
  </ol>
</template>
<script>
export default {
  name: 'BaseList',
  props: { items: Array, uppercase: Boolean },
  data() {
    return {}
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.base-list {
  list-style: none;
  padding: 0 !important;
}
</style>
